import { IActivity } from '../../account/shared/account.service';
import { Account } from './../../account/shared/account.model';
import { User } from '../../user/shared/user.model';

export class Activity implements IActivity {
  id?: string;
  action?: 0 | 1 | 2 | 3;
  account?: Account;
  createdOn?: Date;
  createdBy?: User;
  modifiedOn?: Date;
  modifiedBy?: User;

  constructor(activity?: IActivity) {
    if (activity) {
      this.id = activity.id;
      this.action = activity.action;
      this.account = new Account(activity.account);
      this.createdOn = activity.createdOn;
      this.createdBy = new User(activity.createdBy);
      this.modifiedOn = activity.modifiedOn;
      this.modifiedBy = new User(activity.modifiedBy);
    }
  }
}
